
import { defineComponent, ref } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    pageroute: {
      type: String,
      required: true,
    },
    imagePosition: {
      type: Number,
      required: false,
    },
  },
  setup(props) {
    const pageRoute = props.pageroute
    let pageName = ''
    let pageStr = ''

    if (pageRoute.search('___') !== -1) {
      pageName = pageRoute.substr(0, pageRoute.length - 5)

      if (pageName.search('___') !== -1) {
        pageName = pageName.substr(0, pageName.length - 5)
      }

      pageStr = 'pages.' + pageName
    }

    /*
      Possible values imagePosition (prop):
      1 - Image Left, Text Right (default)
      2 - Image Right, Text Left
    */
    const imagePositionLayout = ref(props.imagePosition)

    if (imagePositionLayout.value !== 2) {
      imagePositionLayout.value = 1
    }

    return { pageRoute, pageName, pageStr, imagePositionLayout }
  },
})
